import React, { memo, forwardRef, useCallback } from 'react';
import cn from 'classnames';
import { useHover } from '@react-aria/interactions';
import { mergeProps } from '@react-aria/utils';
import { usePatchedFocusRing } from '../../hooks';
import styles from './styles.module.css';
export const SwitchBase = memo(forwardRef(function SwitchBase({ disabled, on, size = 'm', onChange, name, hovered, error, focused, className, labelId, ...rest }, ref) {
    return (React.createElement("div", { className: cn(className, styles.switch, styles[size], {
            [styles.disabled]: disabled,
            [styles.hovered]: hovered,
            [styles.error]: error,
            [styles.focused]: focused,
            [styles.on]: on,
        }), ref: ref, ...rest },
        React.createElement("div", { className: styles.track },
            React.createElement("div", { className: styles.button })),
        React.createElement("input", { id: labelId, name: name, type: "checkbox", checked: onChange ? on : undefined, onChange: disabled ? undefined : onChange, className: styles.hiddenInput, readOnly: disabled || !onChange, disabled: disabled || !onChange, tabIndex: disabled ? -1 : undefined })));
}));
export function useSwitch({ onChange, ...rest }) {
    const { hoverProps, isHovered } = useHover({ isDisabled: rest.disabled });
    const { isFocusVisible, focusProps } = usePatchedFocusRing({ within: true });
    const onChangeHandler = useCallback((e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.currentTarget.checked, e);
    }, [onChange]);
    return mergeProps(rest, { onChange: onChangeHandler, hovered: isHovered, focused: isFocusVisible }, hoverProps, focusProps);
}
export const Switch = memo(forwardRef(function Switch(props, ref) {
    const switchProps = useSwitch(props);
    return React.createElement(SwitchBase, { ...switchProps, ref: ref });
}));
